import React from "react";
import { getVisiblePages } from "../utils";
import "./Pagination.css";

const Arrow = ({ double, left }) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden>
    <path
      d={
        double
          ? left
            ? "M7 10L4 7l3-3M11 10L8 7l3-3"
            : "M7 4l3 3-3 3M3 4l3 3-3 3"
          : left
          ? "M8.5 10L5.5 7l3-3"
          : "M5.5 4l3 3-3 3"
      }
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Подвал таблицы: «Показано: N из M» и переключение страниц */
function Pagination({ page, pageSize, total, onChange }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const shown = Math.min(pageSize, Math.max(0, total - (page - 1) * pageSize));

  return (
    <div className="rr-pagination">
      <span className="rr-pagination__info">
        Показано: {shown} из {total}
      </span>
      {totalPages > 1 && (
        <div className="rr-pagination__pages">
          <button type="button" disabled={page === 1} onClick={() => onChange(1)} aria-label="Первая страница">
            <Arrow double left />
          </button>
          <button type="button" disabled={page === 1} onClick={() => onChange(page - 1)} aria-label="Предыдущая страница">
            <Arrow left />
          </button>
          {getVisiblePages(page, totalPages).map((item, index) =>
            item === "ellipsis" ? (
              <span key={`ellipsis-${index}`} className="rr-pagination__ellipsis">
                …
              </span>
            ) : (
              <button
                key={item}
                type="button"
                className={item === page ? "is-active" : undefined}
                onClick={() => onChange(item)}
              >
                {item}
              </button>
            )
          )}
          <button
            type="button"
            disabled={page === totalPages}
            onClick={() => onChange(page + 1)}
            aria-label="Следующая страница"
          >
            <Arrow />
          </button>
          <button
            type="button"
            disabled={page === totalPages}
            onClick={() => onChange(totalPages)}
            aria-label="Последняя страница"
          >
            <Arrow double />
          </button>
        </div>
      )}
    </div>
  );
}

export default Pagination;
